import classNames from 'classnames';
import * as customPropTypes from 'custom-prop-types';
import PropTypes from 'prop-types';

import { LinkListItem } from '@/design-system/atoms/LinkListItem';

import styles from '../../Directory.module.scss';

const LocationList = ({ listItems, analytics, ...props }) => {
    const splitValue = listItems?.length > 0 ? Math.round(listItems.length / 2) : 0;
    const columnOne = listItems?.slice(0, splitValue);
    const columnTwo = listItems?.slice(splitValue);

    return (
        <ul className={styles[`directory__list`]}>
            <span role="presentation" className={styles[`directory__list-column`]}>
                {columnOne?.map(({ itemDescription, ...item }, index) => (
                    <LinkListItem
                        key={index}
                        {...item}
                        linkWrapper="li"
                        description={itemDescription}
                        analytics={analytics}
                    />
                ))}
            </span>
            <span
                role="presentation"
                className={classNames(styles[`directory__list-column`], 'axe-jest-ignore')}
            >
                {columnTwo?.map(({ itemDescription, ...item }, index) => (
                    <LinkListItem
                        key={index}
                        {...item}
                        linkWrapper="li"
                        description={itemDescription}
                        analytics={analytics}
                    />
                ))}
            </span>
        </ul>
    );
};

LocationList.propTypes = {
    listItems: PropTypes.arrayOf(PropTypes.shape(LinkListItem.prototype)),
    analytics: customPropTypes.analyticsPropType,
};
export default LocationList;
